import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    integrationSummaries: {}
  },
  mutations: {
    SET_INTEGRATION_SUMMARIES (store, val) {
      store.integrationSummaries = val
    }
  },
  getters: {
    getIntegrationSummaries: (store) => {
      return store.integrationSummaries
    }
  },
  actions: {
    /*
    setIntegrationSummaries
    */
    setIntegrationSummaries ({commit, dispatch, getters}) {
      return new Promise((resolve, reject) => {
        axios
        .get(`/accounts/${getters.getAccount._id}/integrations/summaries`)
        .then((response) => {
          commit('SET_INTEGRATION_SUMMARIES', response.data)
          resolve(getters.getIntegrationSummaries)
        })
        .catch((err) => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/IntegrationSummaries.js